import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-roles-role-sections-card',
  templateUrl: './roles-role-sections-card.component.html',
  styleUrls: ['./roles-role-sections-card.component.scss']
})
export class RolesRoleSectionsCardComponent implements OnInit {

  @Input() roleInfo;
  @Input() menuSections;
  selectedSections;
  updateRoleMenuOptionsSubscription: Subscription;

  constructor(private rolesService: RolesService,
              private userStorageService: UserStorageService) { }

  ngOnInit() { }

  public updateRoleMenuOptions(menuOptions) {
    this.updateRoleMenuOptionsSubscription = this.rolesService.updateRoleMenuOptions(this.roleInfo.RoleInternalId, this.userStorageService.getCompanyData().CompanyCode, menuOptions).subscribe(
      (res) => {

      },
      (error) => {

      }
    );
  }

  public duallistboxOutputEventReceiver(sections) {
    const aux = new Array();
    for (const d of sections) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.updateRoleMenuOptions(aux);
    }
  }
}
